export var requestVerbs={GET:'GET',POST:'POST',DELETE:'DELETE',PATCH:'PATCH',PUT:'PUT'};